// useConversationSentiment — Polish #13.
//
// Returns the sentiment of the most recent inbound message for a
// conversation. Same 5-minute stale-while-revalidate envelope as the
// briefing hook, so re-opening a thread never re-triggers a Haiku call.
//
// The backend reuses the existing message_tones cache — the chip is
// essentially free except on the first view of a new inbound message.

import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import type { MessageTone } from '@/components/center/ToneChip';

export interface SentimentResponse {
  tone: MessageTone | null;
  messageId: string | null;
  generatedAt: string | null;
}

export function useConversationSentiment(conversationId: string | undefined) {
  return useQuery<SentimentResponse>({
    queryKey: ['conversation-sentiment', conversationId],
    enabled: !!conversationId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: () =>
      apiGet<SentimentResponse>(`/api/conversations/${conversationId}/sentiment`),
  });
}
